import { getViceVersaFullName, resolveRoleName } from './string';

export function sortByName(a, b) {
    return getViceVersaFullName(a).localeCompare(getViceVersaFullName(b));
}

export function sortByPhone(a, b) {
    return (a.phone || '').localeCompare(b.phone || '');
}

export function sortByRoleThenName(a, b, reverseSubsort = false) {
    const aRole = a.roles && a.roles.length > 0 ? resolveRoleName(a.roles[0].role).toString() : '';
    const bRole = b.roles && b.roles.length > 0 ? resolveRoleName(b.roles[0].role).toString() : '';

    if (aRole !== bRole) {
        return aRole.localeCompare(bRole);
    }
    return reverseSubsort ? sortByName(b, a) : sortByName(a, b);
}



// WEBPACK FOOTER //
// ./src/utilities/sortUser.jsx